import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DashboardService } from '@core/services/dashboard.service';
import { DashboardActions } from './dashboard.actions';

@Injectable()
export class DashboardEffects {
  private actions$ = inject(Actions);
  private dashboardService = inject(DashboardService);
  private translateService = inject(TranslateService);
  getDashboards$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadDashboardData),
      mergeMap((data) =>
        this.dashboardService.getDashboardData(data).pipe(
          map((data) => {
            return data.success
              ? DashboardActions.loadDashboardDataSuccess(data)
              : DashboardActions.loadDashboardDataFailure(data);
          }),
          catchError((error) =>
            of(
              DashboardActions.loadDashboardDataFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
